module.exports = __webpack_public_path__ + "img/22.5339fc1d.png";